import React from 'react'
import { useTranslation } from 'react-i18next'

import { formatDate, formatMoney, chequeNumber, regexPhoneNumber } from 'helpers/helpers'
import { toNumber, isPreparedProduct, getPrintProduct, drawingForCheque } from 'helpers/chequePrint'

/**
 * ISH TOPSHIRIG'I — A4, TUNUKAFON sexi uchun.
 *
 * NEGA ALOHIDA MAKET (2026-08-13, foydalanuvchi talabi):
 * Tunukafon buyurtmasida bitta chekда 15 tagacha har xil profil bo'ladi.
 * 80 mm tasmada har biri o'z chizmasi bilan ketma-ket chiqsa qog'oz IKKI
 * METRGA cho'ziladi va usta uni stolga yoyolmaydi. Ustalar hozir buni
 * qo'lda A4 ga chizib olishadi — bitta varaqda 3 ustun, har katakda profil
 * va necha metr kerakligi. Shu qog'ozning bosma varianti.
 *
 * `ChequeWork` (80 mm) BOSHQA bo'limlarga o'z holicha qoladi — profnastil
 * va aksessuarda qator kam, tasma qulayroq.
 *
 * ⚠️ NARX YO'Q. Bu sex qog'ozi; pul ma'lumoti Cheque80/ChequeA4 da.
 */

function ChequeWorkA4({ data = { products: [] }, printChequeRef, show = false }) {
	const { t } = useTranslation()
	const MU = 'm'

	// Faqat TUNUKAFON qatorlari (tur 5). Boshqa turlar bu varaqqa tushmaydi —
	// ular boshqa sexning ishi va bu yerda faqat joy egallardi.
	const items = (data.products || [])
		.filter(p => Number(p.product_type) === 5)
		.map(getPrintProduct)
		.filter(p => p.print_quantity > 0)

	const total = items.reduce((a, it) => {
		if (isPreparedProduct(it)) return { ...a, piece: a.piece + toNumber(it.print_quantity) }
		return {
			piece: a.piece + toNumber(it.print_roll_quantity),
			kv: a.kv + toNumber(it.print_sq_m),
			roll: a.roll + toNumber(it.roll_metr),
		}
	}, { piece: 0, kv: 0, roll: 0 })

	/* ═══ TO'LOV HOLATI (2026-08-15, korxona egasining talabi) ═══
	   Sex yukni chiqarayotganda pul olingan-olinmaganini BILMASDI: haydovchi
	   mijozdan pul olishi kerakmi yoki yo'qmi — varaqda hech narsa yo'q edi.

	   ⚠️ Yuqoridagi «NARX YO'Q» qoidasiga ATAYLAB istisno: bu yerda mahsulot
	      narxi emas, faqat YAKUNIY to'lov holati ko'rsatiladi. Qatorlar
	      hamon narxsiz qoladi — usta nima qancha turishini bilmaydi.

	   Maydonlar `show()` dan keladi (`ch.*`). Invariant prod bazasida
	   tekshirilgan (10 ta tunukafon cheki): total_amount = paid + debt_amount,
	   farq hammasida 0. Shuning uchun «olinadi» uchun `debt_amount` olinadi —
	   u qolgan qarzning O'ZI, ayirib hisoblash shart emas. */
	const payTotal = toNumber(data.total_amount)
	const payPaid  = toNumber(data.paid)
	const payDebt  = toNumber(data.debt_amount)
	const isPaid   = payDebt <= 0
	/* `payment_plan` — sotuvchi tanlagan niyat: cash / half / nasiya / driver.
	   Ustaga eng keragi `driver` («Shofyordan») — pulni haydovchi olib keladimi.

	   ⚠️ Faqat MA'LUM 4 qiymat tekshiriladi: i18next topilmagan kalitni O'ZINI
	      qaytaradi, ya'ni ro'yxatsiz varaqda «plan_xyz» degan xom matn chiqib
	      qolardi. Eski cheklarda `payment_plan` NULL — yorliq umuman yozilmaydi. */
	const planLabel = ['cash', 'half', 'nasiya', 'driver'].includes(data.payment_plan)
		? t(`plan_${data.payment_plan}`)
		: null

	/* Ortiqcha nollarsiz — 80 mm chekдagi `nz()` bilan bir xil qoida.
	   «1.050 × 60.000» emas, «1.05 × 60». */
	const nz = (v, d = 3) => {
		const s = formatMoney(v, d)
		return s.includes('.') ? s.replace(/\.?0+$/, '') : s
	}

	const st = {
		wrap: { color: '#000', fontSize: '12px', fontVariantNumeric: 'tabular-nums' },
		hdr: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' },
		idK: { fontSize: '26px', fontWeight: 900, lineHeight: 1.1 },
		dept: {
			background: '#111722', color: '#fff', fontWeight: 900, fontSize: '15px',
			letterSpacing: '1.5px', padding: '3px 12px', display: 'inline-block',
		},
		meta: { textAlign: 'right', fontSize: '12px', lineHeight: 1.45 },
		metaK: { color: '#000' },
		urg: {
			border: '2px solid #b42318', color: '#b42318', fontWeight: 900,
			fontSize: '13px', padding: '1px 8px', display: 'inline-block', marginLeft: '8px',
		},
		/* TO'LOV BLOKI — ikki ko'rinish.
		   To'lanmaganida QALIN RAMKA: usta varaqqa qaragan zahoti ko'zga
		   tashlanishi kerak, chunki pul olish/olmaslik shunga bog'liq.
		   To'langanida ramka ingichka — e'tibor talab qilmaydi. */
		payBox: {
			border: '2.5px solid #111722', padding: '5px 10px',
			display: 'inline-block', marginTop: '7px', minWidth: '210px',
		},
		payBoxOk: {
			border: '1px solid #111722', padding: '4px 10px',
			display: 'inline-block', marginTop: '7px',
		},
		payHead: {
			display: 'flex', justifyContent: 'space-between', gap: '14px',
			fontWeight: 900, fontSize: '14px', letterSpacing: '0.5px',
		},
		payPlan: { fontWeight: 700, fontSize: '12px' },
		payAmt: { fontWeight: 900, fontSize: '17px', marginTop: '1px' },
		paySub: { fontSize: '11px', marginTop: '1px' },
		sep: { borderTop: '2px solid #111722', margin: '8px 0 10px' },
		/* 3 USTUN — foydalanuvchi qarori (qo'lda chizilgan varaq ham shunday).
		   `auto-rows: auto` — katak balandligi eng uzun chizmaga moslashadi,
		   qatorlar tekis turadi. */
		grid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' },
		cell: { border: '1px solid #111722', padding: '6px 7px', breakInside: 'avoid', pageBreakInside: 'avoid' },
		num: { fontWeight: 900, fontSize: '13px', marginRight: '4px' },
		/* BELGILASH KATAGI — usta bajargan ishini qalam bilan belgilaydi
		   (2026-08-13, foydalanuvchi talabi). 80 mm chekдagi bilan bir xil
		   o'lcham: qalam sig'ishi uchun 16px, chegara 2px (termal qog'ozda
		   ingichka chiziq yo'qoladi, A4 da ham bir xil bo'lgani ma'qul). */
		tick: {
			display: 'inline-block', width: '16px', height: '16px',
			border: '2px solid #111722', marginRight: '6px',
			verticalAlign: '-3px', flex: '0 0 auto',
		},
		pname: { fontWeight: 800, fontSize: '13px', lineHeight: 1.25 },
		roll: { color: '#000', fontSize: '11.5px', fontWeight: 600, marginBottom: '3px' },
		img: { display: 'block', width: '100%', border: '1px solid #000', margin: '3px 0 4px' },
		big: { fontSize: '17px', fontWeight: 900, background: '#fff2c2', padding: '1px 5px', display: 'inline-block' },
		calc: { fontWeight: 700, fontSize: '12px', marginTop: '2px' },
		note: { color: '#000', fontSize: '11px', lineHeight: 1.35 },
		foot: { borderTop: '2px solid #111722', marginTop: '10px', paddingTop: '6px', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' },
		footK: { color: '#000', fontSize: '12px', letterSpacing: '.5px' },
		footV: { fontSize: '18px', fontWeight: 900 },
	}

	const cell = (item, i) => {
		const prepared = isPreparedProduct(item)
		const rollM = toNumber(item.roll_metr)
		const eq = toNumber(item.element_quantity)
		const cuts = eq > 0 ? rollM / eq : 0

		// Yoyma va bo'lak — chizma ichidan (draw_json satr ham, obyekt ham bo'lishi mumkin)
		let dj = item.draw_json
		if (typeof dj === 'string') { try { dj = JSON.parse(dj) } catch (e) { dj = null } }
		const blankMM = toNumber(dj && dj.blank)
		const bolak = toNumber(dj && dj.bolak)

		const png = drawingForCheque(item, 'worker')
		const w = toNumber(item.draw_width) > 0 ? item.draw_width : item.width

		return (
			<div key={i} style={st.cell}>
				<div style={{ display: 'flex', alignItems: 'flex-start' }}>
					<span style={st.tick}></span>
					<div>
						<span style={st.num}>{i + 1}.</span>
						<span style={st.pname}>{item.product_name}</span>
					</div>
				</div>
				{item.element_name && <div style={st.roll}>{item.element_name}</div>}

				{png && <img src={png} alt="" style={st.img} />}

				{prepared ? (
					<div style={st.calc}>
						<span style={st.big}>{nz(item.print_quantity)} {t('piece')}</span>
						<span style={st.note}> · {t('from_warehouse')}</span>
					</div>
				) : (
					<>
						{/* Eng yirik raqam — qo'lda chizilgan varaqdagi «52m» ning o'rni */}
						<div style={st.calc}>
							{nz(eq)} {MU} × {nz(item.print_roll_quantity)} {t('piece')}
							{' = '}<span style={st.big}>{nz(item.print_metr)} {MU}</span>
						</div>
						{/* RULONDAN — mahsulot metridan farq qilganda. Tunukafonda
						    eni rulon enidan kichik bo'lgani uchun deyarli doim farq qiladi:
						    1.05 × 60 dona = 63 m mahsulot, lekin rulondan 31.5 m. */}
						{rollM > 0 && Math.abs(rollM - toNumber(item.print_metr)) > 0.01 &&
							<div style={st.calc}>
								{t('from_roll')}: {nz(rollM)} {MU}
								{cuts > 0 && <span style={st.note}> · {nz(cuts)} {t('cuts')}</span>}
							</div>}
						<div style={st.note}>
							{toNumber(w) > 0 && <>{t('width')}: {formatMoney(w, 4)} {MU}
								{toNumber(item.draw_width) > 0 && <b> ({t('by_drawing')})</b>}</>}
							{blankMM > 0 && <><br />{t('blank')}: {nz(blankMM, 0)} mm
								{bolak > 1 && <> · {t('pieces_per_sheet_short', { n: nz(bolak, 0) })}</>}</>}
						</div>
					</>
				)}
			</div>
		)
	}

	return (
		<div className={`${show ? '' : 'd-none'}`}>
			<div className={`cheque ${show ? 'p-3' : 'a4'}`} ref={printChequeRef} style={st.wrap}>

				<div style={st.hdr}>
					<div>
						<div style={st.idK}>№ {chequeNumber(data)}</div>
						<div style={{ marginTop: '4px' }}>
							<span style={st.dept}>ТУНУКАФОН</span>
							{data.is_urgent && <span style={st.urg}>⚡ {t('urgent')}</span>}
						</div>

						{/* TO'LOV HOLATI — «pul olinganmi, haydovchidan olamizmi» savoliga javob.
							`payTotal > 0` sharti: summasi yo'q chekда blok chiqmasin. */}
						{payTotal > 0 && (
							isPaid ? (
								<div style={st.payBoxOk}>
									<div style={st.payHead}>
										<span>✓ {t('paid')}</span>
										{planLabel && <span style={st.payPlan}>{planLabel}</span>}
									</div>
								</div>
							) : (
								<div style={st.payBox}>
									<div style={st.payHead}>
										<span>{t('not_paid')}</span>
										{planLabel && <span style={st.payPlan}>{planLabel}</span>}
									</div>
									<div style={st.payAmt}>{t('debt')}: {formatMoney(payDebt)}</div>
									{/* Qisman to'langan bo'lsa — qanchasi olinganini ham ko'rsatamiz,
										aks holda usta «umuman to'lamagan» deb tushunadi. */}
									{payPaid > 0 &&
										<div style={st.paySub}>{t('paid')}: {formatMoney(payPaid)}</div>}
								</div>
							)
						)}
					</div>
					<div style={st.meta}>
						<div><span style={st.metaK}>{formatDate(data.cheque_opened_at, 'dd.MM.yyyy HH:mm')}</span></div>
						{data.client_name && <div><b>{data.client_name}</b></div>}
						{/* MIJOZ RAQAMI (2026-08-15) — ilgari faqat ism chiqardi va
							haydovchi yo'lda mijozga qo'ng'iroq qilolmasdi.
							`show()` da `c.phone as client_phone` allaqachon keladi. */}
						{data.client_phone &&
							<div style={{ fontWeight: 700 }}>{regexPhoneNumber(data.client_phone)}</div>}
						{[data.client_region, data.address].filter(Boolean).length > 0 &&
							<div>{[data.client_region, data.address].filter(Boolean).join(', ')}</div>}
						{data.cashier_name && <div><span style={st.metaK}>{t('seller')}: </span>{data.cashier_name}</div>}
						{data.delivery_date &&
							<div><span style={st.metaK}>{t('deadline')}: </span>
								<b>{formatDate(data.delivery_date, 'dd.MM.yyyy HH:mm')}</b></div>}
						{/* YETKAZIB BERISH TURI + NARXI (2026-08-28, egasining talabi).
						    Sex tayyor mahsulotni qanday chiqarishni bilishi kerak: o'zi olib
						    ketadimi, dostavka bormi. Narx FAQAT belgilangan bo'lsa chiqadi —
						    tekin/o'zi oladigan chekda ortiqcha qator bo'lmasin. */}
						{(data.delivery_type_name || Number(data.delivery_price) > 0) &&
							<div>
								<span style={st.metaK}>{t('delivery')}: </span>
								<b>{data.delivery_type_name || '—'}</b>
								{Number(data.delivery_price) > 0 &&
									<> · <b>{formatMoney(data.delivery_price)}</b></>}
							</div>}
					</div>
				</div>

				<div style={st.sep}></div>

				{items.length === 0
					? <div style={{ ...st.note, textAlign: 'center', padding: '18px 0' }}>{t('wo_empty')}</div>
					: <div style={st.grid}>{items.map(cell)}</div>}

				{items.length > 0 &&
					<div style={st.foot}>
						<span style={st.footK}>{t('total')}</span>
						<span style={st.footV}>
							{[
								total.piece > 0 ? `${nz(total.piece)} ${t('piece')}` : null,
								total.kv > 0 ? `${nz(total.kv)} ${t('sq_m')}` : null,
								total.roll > 0 ? `${t('from_roll')}: ${nz(total.roll)} ${MU}` : null,
							].filter(Boolean).join(' · ')}
						</span>
					</div>}
			</div>
		</div>
	)
}

export default ChequeWorkA4
